module.exports = __webpack_public_path__ + "img/proxyService.479dd759.png";